import React from 'react';
import { CircleMarker, Popup } from 'react-leaflet';
import { useMap } from '../../../contexts/MapContext';
import { transformCoordinate } from '../../../utils/coordinateTransform';

const DamageAssessmentLayer: React.FC = () => {
  const { gazaPosition } = useMap();
  
  // Sample damage points in Gaza's actual coordinates
  const damagePointsOriginal = [
    { id: 1, lat: 31.5245, lng: 34.4444, level: 'destroyed', count: 100, area: 'Al-Shifa area' },
    { id: 2, lat: 31.5156, lng: 34.4389, level: 'severe', count: 75, area: 'Gaza City center' },
    { id: 3, lat: 31.4800, lng: 34.4300, level: 'moderate', count: 50, area: 'Southern Gaza' },
    { id: 4, lat: 31.3444, lng: 34.3056, level: 'severe', count: 85, area: 'Khan Yunis' },
    { id: 5, lat: 31.2833, lng: 34.2556, level: 'destroyed', count: 120, area: 'Rafah' },
    { id: 6, lat: 31.5500, lng: 34.4700, level: 'moderate', count: 40, area: 'Northern Gaza' },
  ];

  const getColor = (level: string) => {
    switch (level) {
      case 'destroyed': return '#8B0000';
      case 'severe': return '#FF4500';
      case 'moderate': return '#FFA500';
      default: return '#FFD700';
    }
  };

  // Transform coordinates to match overlay position
  const transformedPoints = damagePointsOriginal.map(point => {
    const transformed = transformCoordinate(point.lat, point.lng, gazaPosition);
    if (!transformed) return null;
    
    return {
      ...point,
      transformedLat: transformed[0],
      transformedLng: transformed[1],
    };
  }).filter(Boolean);

  if (!gazaPosition) return null;

  return (
    <>
      {transformedPoints.map((point) => (
        point && (
          <CircleMarker
            key={point.id}
            center={[point.transformedLat, point.transformedLng]}
            radius={Math.sqrt(point.count) * 2}
            pathOptions={{
              color: getColor(point.level),
              fillColor: getColor(point.level),
              fillOpacity: 0.5,
              weight: 2,
            }}
          >
            <Popup>
              <div style={{ minWidth: '150px' }}>
                <strong>{point.area}</strong>
                <br />
                <span style={{ color: getColor(point.level), fontWeight: 'bold' }}>
                  {point.level.toUpperCase()}
                </span>
                <br />
                Structures affected: {point.count}
                <br />
                <small style={{ color: '#666' }}>
                  Data from UNOSAT damage assessment
                </small>
              </div>
            </Popup>
          </CircleMarker>
        )
      ))}
    </>
  );
};

export default DamageAssessmentLayer;